export default __webpack_public_path__ + "static/media/head-shark.77294587.png";